import { createApi } from '@reduxjs/toolkit/query/react'
import qs from 'qs'
import {
	selectResultsToSkip,
	selectWorklistFilters,
} from '../features/worklist/selectors'
import { staggeredBaseQueryWithBailOut } from '../libs/services'
import { FIVE_MINUTES } from '../libs/time'
import { parseWorklistFiltersToQuery } from '../libs/worklist'
import { WorklistExam, WorklistExamsQuery } from '../model/exam'
import { useTeloSelector } from '../store'
import { unversionedApiUrl } from './common'

type WorklistExamsQueryResult = {
	exams: WorklistExam[]
	totalResults: number
}

export const WORKLIST_CACHE_TAG = 'worklist'

export const worklistApi = createApi({
	reducerPath: 'worklistApi',
	baseQuery: staggeredBaseQueryWithBailOut(`${unversionedApiUrl}/v3`),
	refetchOnMountOrArgChange: true,
	tagTypes: [WORKLIST_CACHE_TAG],
	endpoints: builder => ({
		getWorklist: builder.query<WorklistExamsQueryResult, WorklistExamsQuery>({
			query: query => ({
				url: `/worklist?${qs.stringify(query)}`,
				headers: {
					'x-store': query.storeId,
				},
			}),
			extraOptions: { maxRetries: 1 },
			providesTags: [WORKLIST_CACHE_TAG],
		}),
	}),
})

export const useGetWorklistQuery = (storeId?: string) => {
	const worklistFilters = useTeloSelector(selectWorklistFilters)
	const resultsToSkip = useTeloSelector(selectResultsToSkip)

	const filtersToApply: WorklistExamsQuery = {
		...parseWorklistFiltersToQuery(worklistFilters),
		storeId,
		skip: resultsToSkip,
	}

	return worklistApi.useGetWorklistQuery(filtersToApply, {
		pollingInterval: FIVE_MINUTES,
	})
}
